import React, { useEffect, useRef } from 'react';
import './Marquee.css';

const items = [
  'Workflow Automation',
  'AI Assistants',
  'Custom AI Builds',
  'Process Digitalization',
  'Sales Automation',
  'Document Intelligence',
  'Voice & Audio AI',
  'Operational Leverage',
];

// Scroll-velocity reaction: the strip skews and accelerates with
// scroll speed, then relaxes — gives the page a sense of inertia.
function useScrollVelocity(trackRef) {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let lastY = window.scrollY;
    let velocity = 0;
    let raf;

    const loop = () => {
      const y = window.scrollY;
      velocity = velocity * 0.88 + (y - lastY) * 0.12;
      lastY = y;
      const track = trackRef.current;
      if (track) {
        const skew = Math.max(-10, Math.min(10, velocity * 0.45));
        track.style.setProperty('--marquee-skew', `${skew}deg`);
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [trackRef]);
}

export default function Marquee() {
  const trackRef = useRef(null);
  useScrollVelocity(trackRef);

  const row = items.map((item, i) => (
    <React.Fragment key={i}>
      <span className="marquee-item">{item}</span>
      <span className="marquee-sep" aria-hidden="true">✦</span>
    </React.Fragment>
  ));

  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track" ref={trackRef}>
        {row}
        {row}
      </div>
    </div>
  );
}
